import { ErrorLogMetaItemType, ErrorLogType } from 'types/error-log';
import {
  formatErrorLogType,
  formatErrorLogUser,
  formatLoggedAt
} from 'utils/error-log/format';
import { getSafeHttpUrlHref } from 'utils/error-log/is-safe-http-url';

type ErrorLogMetaProps = {
  log: ErrorLogType;
};

export default function ErrorLogMeta({ log }: ErrorLogMetaProps) {
  const items: ErrorLogMetaItemType[] = [
    { label: 'Error type', value: formatErrorLogType(log.errorType) },
    { label: 'Logged at', value: formatLoggedAt(log.createdAt) },
    {
      label: 'User',
      value: log.userEmail
        ? `${formatErrorLogUser(log)} (${log.userEmail})`
        : formatErrorLogUser(log)
    },
    { label: 'Page', value: log.page },
    {
      label: 'URL',
      value: log.url,
      href: getSafeHttpUrlHref(log.url),
      breakAll: true
    },
    { label: 'Browser', value: log.userAgent ?? '—', breakAll: true }
  ];

  return (
    <dl className='grid h-full grid-cols-1 gap-3 rounded-md bg-gray-50 p-4 text-sm md:grid-cols-2'>
      {items.map((item) => (
        <div key={item.label} className='flex flex-col gap-0.5'>
          <dt className='text-xs font-semibold uppercase tracking-wide text-gray-500'>
            {item.label}
          </dt>
          <dd
            className={
              item.breakAll ? 'break-all text-gray-900' : 'text-gray-900'
            }
          >
            {item.href ? (
              <a
                href={item.href}
                target='_blank'
                rel='noreferrer'
                className='text-blue-600 hover:underline'
              >
                {item.value}
              </a>
            ) : (
              item.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
